<template>
	<div id="usre-baseinfor" class="oh" > 
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>                                      
			</el-dialog>
			<div class="index_left_centerpage" v-if="infobtn"> 
			 <div class="enterprise_detail gov_enterprise_detail">
			 	<div class="whitebox centerpage"> 
					<div class="d_blocktitle">
						<i class="title-icon title-icon1"></i>
						<h3 class="ctitle">{{detailInfor.baseInfo.town}}-{{detailInfor.baseInfo.title}}</h3> 
						<!-- <p>{{companyinfor.addCRMid}}</p> --> 
						<span :class="detailInfor.baseInfo.collectId == 0?'collectbtn add fr':'collectbtn remove fr'" @click="collectFun()">{{detailInfor.baseInfo.collectId == 0?'加入':'取消'}}关注</span> 
					</div>
					<ul class="oh conpany-infor-new">
						<li class="inforLine inforLine-3 longlabel" v-for="infor in detailInfor.macroData" ><span class="label">{{infor.text}}：</span><span class="infortext">{{infor.value}} {{infor.unit}}</span></li>
						</ul>
				 
				<!-- 	<p class="companyinfor oneline" >
						<i>专业镇简介：</i><em>{{detailInfor.macroData.businessScope}}xxxxxxxxxxxxxxxxxx 预留 暂时没有数据，后期补充</em>
					</p> -->
					</div>
					<div class="whitebox" style="padding-top:10px;">
						<div class="bdbe">
							<div class="w95mg acoltitle"><span class="" style="margin-right: 30px;">招商企业</span>  </div> 
						</div> 
						<p class="enterparise_guide oh w95mg">产业大脑为您找到{{total}}条相关结果</p> 
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" style="margin-bottom: 120px;">
							<tr>
								<th class="xuhao">序号</th>
								<th>企业名称</th>
								<th>注册资本</th>
								<th>所属产业</th>
								<th>所属城市</th>
								<th>详细地址</th>
							</tr>
							<tr v-for="(list,index) in enterpriselist">
								<td>{{(page-1)*pageSize+index+1}}</td>
								<td v-if="list.stockCode!=''"><span class="title onlinetitle curp" @click="routerlinkid('/enterprises',list.stockCode)">{{list.title}}</span></td>
								<td v-if="list.stockCode==''">{{list.title}}</td>
								<td>{{list.regCapital.length>0?list.regCapital:'-'}}</td>
								<td>{{list.industry.length>0?list.industry:'-'}}</td>
								<td>{{list.area.length>0?list.area:'-'}}</td>
								<td>{{list.address.length>0?list.address:'-'}}</td>
							</tr>
						</table>
						<div class="centerpage1 company_pagelist" v-show="totalPage>1">
							<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"	v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
						</div>
					</div>
			</div>
		</div>
	</div>
	</div>
</template> 
<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
	  name: 'cocDetail',
	  computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
	  data(){return{
				userdata:{}, enterpriseid:0,specialTownID:0,
				title:' ', infobtn:false,
				detailInfor:{},
				enterpriselist:[],
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				isShowFreeUserTips:false,
			}},
		 created() {
		 this.$nextTick(() => {
		 	// 禁用右键
		 	document.oncontextmenu = new Function("event.returnValue=false");
		 	// 禁用选择
		 	document.onselectstart = new Function("event.returnValue=false");
		 });
		 this.userdata=this.getuseriformation(); 
		 this.specialTownID = this.$route.query.id;  
		 // this.bus.$emit('loading', true);
		 },
			mounted() { 
			 this.getbaseinfor(1);
			 // this.getenterpriseList()
			},
			methods:{  
			 //添加删除收藏
			//获取基本信息
			getbaseinfor(pages){
					this.bus.$emit('loading', true);
				var _this=this; 
				this.page=pages;
				this.$axios.get(this.$api.free.specialTown.detail()+'?id='+this.specialTownID ).then(function(res) {
					console.log('获取基本信息a',res.data);
					if(res.data.success){ 
					 _this.detailInfor=res.data.data; 
						document.title=_this.detailInfor.baseInfo.town+"-产业研究大脑体验版";
					_this.enterpriselist=res.data.list;
					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.infobtn=true;
					_this.bus.$emit('loading', false);
					} else {
						// 
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			}, 
			//添加删除收藏
			collectFun(){
				// console.log(this.companyinfor.collectId,this.companyinfor);
				this.listToggleCollect(this.detailInfor.baseInfo,'acoc'); 
			}, 
			//分页跳页 
			pageHandler: function(page) { 
				if(page>1){
					this.isShowFreeUserTips = true;
					return;
				}
				this.getbaseinfor(page); 
			},	 
			}
	}  
</script>

<style scoped>
	.companyinfor i{
		width: 190px;
	}
</style>
